__turbopack_context__.v({
  "className": "hanken_grotesk_c5d024c9-module__G0nL8a__className",
});
